import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeftIcon } from '@grupoboticario/flora-react-icons';
import { PaymentMethods } from 'core/domains/checkout';
import { Layout, ResponsiveFloraTypography } from 'ui/components';
import { PaymentGroupMethodSelect } from './PaymentGroupMethodSelect';
import { PaymentGroupSelect } from './PaymentGroupSelect';
import S from './PaymentsGroup.styles';

export const PaymentsGroup = (paymentMethods: PaymentMethods) => {
  const [selectedGroup, setSelectedGroup] = useState<keyof PaymentMethods | null>(null);
  const paymentTitle =
    paymentMethods[selectedGroup as keyof PaymentMethods]?.textQuestion ??
    'Escolha o número de parcelas';
  const history = useHistory();
  const title = selectedGroup ? paymentTitle : 'Escolha a forma de pagamento';

  return (
    <>
      <Layout verticalAlign="top">
        <ResponsiveFloraTypography
          as={'h5'}
          css={{ margin: '0 0 $3 0' }}
          tabIndex={0}
          aria-label={title}
          fontSize="subtitle"
          fontWeight="regular"
          color="$nonInteractivePredominant"
        >
          {title}
        </ResponsiveFloraTypography>
      </Layout>
      <Layout alternateColor={true} horizontalAlign="left">
        <S.PaymentsContainer>
          {selectedGroup === null ? (
            <PaymentGroupSelect
              setSelectedGroup={setSelectedGroup}
              paymentMethods={paymentMethods}
            />
          ) : (
            <PaymentGroupMethodSelect
              selectedGroup={selectedGroup}
              paymentMethods={paymentMethods}
            />
          )}
        </S.PaymentsContainer>
      </Layout>
      <S.BackToCartButton
        hierarchy="secondary"
        data-testid="payment-group-back-button"
        css={{ width: '100%', marginTop: '$4' }}
        onClick={() => (selectedGroup ? setSelectedGroup(null) : history.push('/carrinho'))}
        aria-label="Voltar"
        has="iconLeft"
        icon={<ArrowLeftIcon size={16} css={{ marginRight: '$2' }} />}
      >
        {selectedGroup ? 'Voltar' : 'Voltar para carrinho'}
      </S.BackToCartButton>
    </>
  );
};
